import { PaginationInstance } from 'ngx-pagination';

export const paginationConfig: () => PaginationInstance = () => ({
  itemsPerPage: 5,
  currentPage: 1,
});
